import React, { useEffect, useState, useRef } from "react";

import { connect } from "react-redux";
import classnames from "classnames";

import * as actions from "../../../../../store/actions";
import { useInfiniteScroll } from "../../../../../utils/pagination";

import SearchBox from "../../../../../components/formElements/searchbox/SearchBox";
import ParticipantsList from "./ParticipantsList";
import LoadingSpinner from "../../../../../components/uiElements/loadingSpinner/LoadingSpinner";
import SelectInput from "../../../../../components/formElements/selectInput/SelectInput";
import Button from "../../../../../components/formElements/button/Button";
import SpinnerBorder from "../../../../../components/uiElements/loadingSpinner/SpinnerBorder";

const AddParticipants = ({
  appointments,
  ongoingAppointment,
  apiUtil,
  personalInfo,
  getSpecialityList,
  setOngoingAppointmentData,
  searchPhysicians,
  removeParticipants,
  addParticipant,
  futureAppointment,
  appointmentFlow,
  addGuestDoctor,
  onClose,
  onGuestSuccess,
}) => {
  const [page, setPage] = useState(0);
  const [selectedOption, setSelectedOption] = useState(0);

  const appointment =
    (appointments?.appointmentDetail &&
      "id" in appointments?.appointmentDetail &&
      appointments?.appointmentDetail) ||
    (appointments?.schAppointmentDetail &&
      "id" in appointments?.schAppointmentDetail &&
      appointments?.schAppointmentDetail) ||
    (ongoingAppointment?.visitNow &&
      "id" in ongoingAppointment?.visitNow &&
      ongoingAppointment?.visitNow);

  const loader = useRef(null);
  useEffect(() => {
    removeParticipants();
    getSpecialityList();

    futureAppointment &&
      setOngoingAppointmentData({
        selectedPhysician: undefined,
      });

    //eslint-disable-next-line
  }, [getSpecialityList, removeParticipants]);

  useInfiniteScroll(loader, () => {
    setPage(page => page + 1);
  });

  useEffect(() => {
    if (
      page > 0 &&
      page <= ongoingAppointment?.total_pages &&
      !ongoingAppointment?.searchValue &&
      !selectedOption
    ) {
      searchPhysicians(
        appointment?.patient_detail?.id || appointment?.patient?.id,
        "",
        undefined,
        futureAppointment ? [true, false] : [true],
        page
      );
    } else if (
      ongoingAppointment?.searchValue &&
      ongoingAppointment?.searchValue.length >= 3 &&
      page > 0 &&
      page <= ongoingAppointment?.total_pages
    ) {
      searchPhysicians(
        appointment?.patient_detail?.id || appointment?.patient?.id,
        ongoingAppointment?.searchValue,
        undefined,
        futureAppointment ? [true, false] : [true],
        page
      );
    } else if (
      selectedOption &&
      page > 0 &&
      page <= ongoingAppointment?.total_pages
    ) {
      searchPhysicians(
        appointment?.patient_detail?.id || appointment?.patient?.id,
        "",
        selectedOption,
        futureAppointment ? [true, false] : [true],
        page
      );
    }

    //eslint-disable-next-line
  }, [page, selectedOption, ongoingAppointment?.searchValue]);

  const customStyles = {
    control: base => ({
      ...base,
      height: 45,
      minHeight: 45,
      borderRadius: "50rem",
      boxShadow: "none",
      zIndex: "3",
    }),
  };

  return (
    <div
      className={classnames(futureAppointment ? "" : "participant-container")}
    >
      <div
        className={classnames(
          "notes p-0 m-0 ",
          futureAppointment && "row",
          futureAppointment ? "mt-3" : "participant-header"
        )}
      >
        <div
          className={classnames(
            futureAppointment ? "col-md-8" : "col-md-12 mt-3 mx-auto pr-0"
          )}
        >
          <SearchBox
            value={ongoingAppointment?.searchValue}
            onChange={val => {
              setOngoingAppointmentData({
                searchValue: val,
                total_pages: 1,
              });
              setPage(1);
            }}
          />
        </div>
        <div
          className={classnames(
            futureAppointment ? "col-md-4 p-0 m-0" : "col-md-8 ml-auto mt-2"
          )}
        >
          <SelectInput
            isSearchable={false}
            isClearable={true}
            menuPlacement="bottom"
            options={personalInfo?.specialitiesOptions}
            placeholder="Speciality"
            styles={customStyles}
            value={selectedOption}
            onChange={val => {
              setSelectedOption(val);
              setOngoingAppointmentData({
                selectedSpeciality: val,
                total_pages: 1,
              });
              setPage(1);
            }}
          />
        </div>
      </div>
      <ParticipantsList
        physicians={ongoingAppointment?.physicians}
        searchedPhysicians={ongoingAppointment?.search}
        searchValue={ongoingAppointment?.searchValue}
        selectedSpeciality={ongoingAppointment?.selectedSpeciality}
        futureAppointment={futureAppointment}
        selectedId={ongoingAppointment?.selectedPhysician}
        setSelectedId={id =>
          setOngoingAppointmentData({
            selectedPhysician: id,
          })
        }
      />
      <div ref={loader}></div>
      {apiUtil.isLoading &&
        (!futureAppointment ? (
          <div className="center-content">
            <LoadingSpinner asOverlay={true} />
          </div>
        ) : (
          <SpinnerBorder isCenter />
        ))}

      <div
        className={classnames(
          "sticky-bottom col-md-3 position-fixed",
          futureAppointment &&
            "d-flex justify-content-center col-md-12 position-sticky"
        )}
      >
        <Button
          label={"Add"}
          disabled={ongoingAppointment?.selectedPhysician ? false : true}
          className={futureAppointment && "col-md-8"}
          onClick={() => {
            futureAppointment && onClose();

            futureAppointment
              ? addGuestDoctor(
                  ongoingAppointment?.selectedPhysician,
                  appointmentFlow,
                  () => onGuestSuccess()
                )
              : addParticipant(ongoingAppointment?.selectedPhysician);
          }}
        />
      </div>
    </div>
  );
};

const mapStoreToProps = ({ dashboard, api, onboarding }) => ({
  personalInfo: onboarding?.personalInfo,
  appointments: dashboard.appointments,
  ongoingAppointment: dashboard.ongoingAppointment,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  getSpecialityList: () => dispatch(actions.getSpecialityList()),
  setOngoingAppointmentData: updatedData =>
    dispatch(actions.setOngoingAppointmentData(updatedData)),
  searchPhysicians: (q, name, speciality, is_available, page) =>
    dispatch(actions.searchPhysicians(q, name, speciality, is_available, page)),
  removeParticipants: () => dispatch(actions.removeParticipants()),
  addParticipant: (physicianId, cb) =>
    dispatch(actions.addParticipant(physicianId, cb)),
  updateGuestDoctorRequest: physicianId =>
    dispatch(actions.updateGuestDoctorRequest(physicianId)),
  addGuestDoctor: (physicianId, appointmentFlow, cb) =>
    dispatch(actions.addGuestDoctor(physicianId, appointmentFlow, cb)),
});

export default connect(mapStoreToProps, mapDispatchToProps)(AddParticipants);
